import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'
import DailyRemainingBudgetFields from './DailyRemainingBudgetFields'

import { TARGET_ROAS } from '../../../../../Multiplatform/CampaignForms/fields'
import { DISPLAY_TYPE } from '../../../../CampaignForms/CampaignGoogleCreate/CampaignGoogleCreateForm/fields'
import { CAMPAIGN_TYPE } from '../fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const BudgetFields = ({ formik, remainingBudget, startDate, endDate }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values } = formik

  const isDisplayTypeCampaign = values[CAMPAIGN_TYPE] === DISPLAY_TYPE

  return (
    <>
      <div className={drawerFormClasses.subSection}>
        <DailyRemainingBudgetFields
          formik={formik}
          remainingBudget={remainingBudget}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
      {!isDisplayTypeCampaign && (
        <div className={drawerFormClasses.subSection}>
          <FieldLabelWrapper label={t('Target ROAS (Optional)')} labelFor={TARGET_ROAS}>
            <p>
              {t(
                "If you track return on ad spend (ROAS), please enter a target for this campaign. If you don't track this metric, or aren't sure, leave this blank."
              )}
            </p>
            <Field
              type="number"
              formik={formik}
              name={TARGET_ROAS}
              placeholder={t('TARGET ROAS')}
              autoComplete="off"
              inputMode="numeric"
            />
          </FieldLabelWrapper>
        </div>
      )}
    </>
  )
}

export default BudgetFields
